import React from 'react';
import { Megaphone } from 'lucide-react';

const AnnouncementsSection = () => {
  const logos = [
    {
      id: 1,
      name: '7 Wonders of Nature',
      image: '/assets/images/NEW_7_WONDERS-1769139390900.png',
      alt: '7 Wonders of Nature logo featuring mountain landscape with dramatic peaks and natural scenery representing global natural heritage recognition',
      url: 'https://world.new7wonders.com/'
    },
    {
      id: 2,
      name: 'UNESCO World Heritage',
      image: '/assets/images/UNESCO_LOGO-1769139474147.png',
      alt: 'UNESCO World Heritage Site emblem with iconic temple architecture symbolizing cultural and natural heritage protection worldwide',
      url: 'https://whc.unesco.org/'
    },
    {
      id: 3,
      name: 'Ramsar Convention',
      image: '/assets/images/ramsar-1769139546957.png',
      alt: 'Ramsar Convention wetlands logo featuring pristine wetland ecosystem with water birds and aquatic vegetation representing international wetland conservation',
      url: 'https://www.ramsar.org/'
    }
  ];

  return (
    <section className="py-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-green-50 to-blue-50 dark:from-gray-800 dark:to-gray-900">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center gap-2 mb-4">
            <Megaphone className="w-8 h-8 text-green-600 dark:text-green-400" />
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white">
              Announcements
            </h2>
          </div>
          <p className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto">
            Stay informed about the latest updates and news from Puerto Princesa Subterranean River National Park
          </p>
        </div>

        {/* Recognition Logos */}
        <div className="mb-12">
          <h3 className="text-xl font-semibold text-center text-gray-800 dark:text-gray-200 mb-6">
            Internationally Recognized Protected Area
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-5xl mx-auto">
            {logos?.map((logo) => (
              <a
                key={logo?.id}
                href={logo?.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-white dark:bg-gray-800 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 p-6 flex flex-col items-center justify-center transform hover:-translate-y-2"
              >
                <div className="w-full h-32 mb-4 overflow-hidden rounded-lg bg-white p-2">
                  <img
                    src={logo?.image}
                    alt={logo?.alt}
                    className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <h4 className="text-center font-semibold text-gray-900 dark:text-white group-hover:text-green-600 dark:group-hover:text-green-400 transition-colors">
                  {logo?.name}
                </h4>
              </a>
            ))}
          </div>
        </div>

        {/* Announcement Content Placeholder */}
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6 sm:p-8 max-w-4xl mx-auto">
          <div className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <div className="w-12 h-12 bg-green-100 dark:bg-green-900 rounded-full flex items-center justify-center">
                <Megaphone className="w-6 h-6 text-green-600 dark:text-green-400" />
              </div>
            </div>
            <div className="flex-1">
              <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
                Park Maintenance Schedule Update
              </h3>
              <div className="text-gray-600 dark:text-gray-300 space-y-2">
                <p>
                  <strong>Important Notice:</strong> The underground river tour will undergo scheduled maintenance from January 20-22, 2026.
                </p>
                <p className="mt-3">During this period:</p>
                <ul className="list-disc ml-6 space-y-1">
                  <li>Tours will be limited to morning slots only (8:00 AM - 12:00 PM)</li>
                  <li>Maximum capacity reduced to 50 visitors per day</li>
                  <li>Alternative activities available at the Visitor Center</li>
                </ul>
                <p className="mt-3">
                  We apologize for any inconvenience. For rebooking assistance, please contact our visitor services team.
                </p>
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-4 italic">
                  Last updated: January 15, 2026
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-8 text-center">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            For more information, visit our{' '}
            <a href="/visitor-planning-hub" className="text-green-600 dark:text-green-400 hover:underline font-medium">
              Visitor Planning Hub
            </a>
            {' '}or contact our support team.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AnnouncementsSection;